/**
 * Custom logging utility that provides styled console output when debugging is enabled.
 * Supports regular logging, collapsible groups, and table formatting with color-coded status styles.
 * Only outputs logs when DEBUG flag is true.
 */
(function (g) {
  const DEBUG = true,
    styles = {
      success: "background: darkgreen; color: white; padding: 2px 6px; border-radius: 3px",
      error: "background: darkred; color: white; padding: 2px 6px; border-radius: 3px",
      warning: "background: darkorange; color: white; padding: 2px 6px; border-radius: 3px",
      info: "background: blue; color: white; padding: 2px 6px; border-radius: 3px"
    };

  function log(...args) { DEBUG && console.log(...args); }
  function collapse(type, data, title = "Log", status = "info") {
    if (!DEBUG) return;
    console.groupCollapsed(`%c ${title}`, styles[status] || styles.info),
      type === "table" ? console.table(data) : console.log(data),
      console.groupEnd();
  }
  log.table = (data, title, status) => collapse("table", data, title, status);
  log.collapse = (data, title, status) => collapse("log", data, title, status);
  g.log = log;
})(typeof window !== "undefined" ? window : globalThis);


/**
 * Initializes and manages a Slick carousel with separate mobile and desktop configurations.
 * Ensures no unnecessary reinitialization during window resizing.
 *
 * @param {jQuery} carousel - The carousel element(s).
 * @param {Object} mobileOptions - Slick options for mobile view.
 * @param {number} breakpoint - The breakpoint to switch between mobile and desktop configurations.
 * @param {Object|null} desktopOptions - Slick options for desktop view. If null, unslick on desktop.
 */
function handleResponsiveCarousel(carousel, mobileOptions, breakpoint = 1024, desktopOptions = null) {
  let currentView = null; // Keeps track of the current view ('mobile' or 'desktop')

  function initializeCarousel() {
    const isDesktop = $(window).width() >= breakpoint;

    if (isDesktop) {
      if (currentView !== 'desktop') {
        // Switch to desktop view
        if (carousel.hasClass('slick-slider')) carousel.slick('unslick'); // Destroy mobile Slick if initialized
        if (desktopOptions) carousel.slick(desktopOptions); // Initialize with desktop options
        currentView = 'desktop';
      }
    } else {
      if (currentView !== 'mobile') {
        // Switch to mobile view
        if (carousel.hasClass('slick-slider')) carousel.slick('unslick'); // Destroy desktop Slick if initialized
        carousel.slick(mobileOptions); // Initialize with mobile options
        currentView = 'mobile';
      }
    }
  }

  initializeCarousel();
  $(window).on('resize', function () {
    initializeCarousel();
  });
}

// Function to copy text to clipboard
function copyToClipboard(text) {
  var $tempInput = $("<input>");
  $("body").append($tempInput);
  $tempInput.val(text).select();
  document.execCommand("copy");
  $tempInput.remove();
}



$(document).ready(function () {
  const useChevron = false;
  const icons = {
    arrow_left: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Left.svg?v=1744058170',
    arrow_right: 'https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Right.svg?v=1744058170',
    chevron_left: 'https://cdn.shopify.com/s/files/1/0679/7135/0705/files/Chevron_Left.png?v=1737122129',
    chevron_right: 'https://cdn.shopify.com/s/files/1/0679/7135/0705/files/Chevron_Right.png?v=1737122129'
  };
  const buttons = {
    prevArrow: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'><img class='left_arrow' src='${useChevron ? icons.chevron_left : icons.arrow_left}' alt='arrow'/></button>`,
    nextArrow: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'><img class='right_arrow' src='${useChevron ? icons.chevron_right : icons.arrow_right}' alt='arrow'/></button>`
  }

  $('.testimonials__cards').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '40px',
    arrows: true,
    dots: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          centerPadding: '30px'
        }
      }
    ]
  });

  $('.video-reviews__wrapper').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    variableWidth: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.product-showcase__products.pdp-description').slick({
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2
  });

  $('.hmh__reviews').slick({
    infinite: false,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.pdp-main__images .product-images[data-images="all"]').slick({
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  $('.pdp-main__images .product-images[data-images="remaining"].thumb').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    variableWidth: false
  });

  const TPReviews = $('.tp-reviews__cards');
  const TPRevewsOptions = {
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const TPRevewsDesktopOptions = $('.tp-reviews__cards.desktop-carousel').length ? {
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2
  } : null;

  const ProductShowcase = $('.product-showcase__products:not(.pdp-description)');
  const ProductShowcaseOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2
  };
  const IngredientsCarousel = $('.ingredients__items--carousel');
  const IngredientsCarouselOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const AthletsCarousel = $('.bd_aths_cont.slick-progress');
  const AthletsCarouselOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "30px",
  };

  handleResponsiveCarousel(TPReviews, TPRevewsOptions, 1024, TPRevewsDesktopOptions);
  handleResponsiveCarousel(ProductShowcase, ProductShowcaseOptions, 753);
  handleResponsiveCarousel(IngredientsCarousel, IngredientsCarouselOptions, 753);
  handleResponsiveCarousel(AthletsCarousel, AthletsCarouselOptions, 753);

  // Video reviews --------------------------------------------------------
  $('.video-reviews__video-button.play, .video-reviews__video').click(function () {
    const $videoWrapper = $(this).is('.video-reviews__video') ? $(this) : $(this).closest('.video-reviews__video');
    const $video = $videoWrapper.find('video');

    if ($video.length) {
      if (!$video.get(0).paused) {
        $video.get(0).pause();
        $videoWrapper.removeClass('play').find('.video-reviews__video-button.pause').hide();
        $videoWrapper.find('.video-reviews__video-button.play').css('display', 'flex');
        return;
      }
      $('.video-reviews__video').each(function () {
        const $otherWrapper = $(this);
        const $otherVideo = $otherWrapper.find('video');
        if ($otherVideo.get(0) !== $video.get(0)) {
          $otherVideo.prop('muted', true).get(0).pause();
          $otherWrapper.removeClass('play').find('.video-reviews__video-button.play').css('display', 'flex');
          $otherWrapper.find('.video-reviews__video-button.pause').hide();
        }
      });

      $video.prop('muted', false).prop("volume", 0.5).get(0).play();
      $(this).is($videoWrapper) ? $videoWrapper.find('.video-reviews__video-button.play').hide() : $(this).hide();
      $videoWrapper.addClass('play').find('.video-reviews__video-button.pause').css('display', 'flex');
    }
  });
  $('.video-reviews__video-button.play').click(function (e) {
    e.stopPropagation();
  })



  // Announcement Timer
  function AnnouncementTimer() {
    const timerWrap = $('.announcement__timer');
    if (!timerWrap.length) return;

    const timer = timerWrap.find('.timer');
    let time;

    const timerDate = timerWrap.data('timer-date');
    if (timerDate) {
      const targetTime = new Date(timerDate + "T00:00:00"); // Local midnight of the given date
      time = Math.floor((targetTime - new Date()) / 1000); // Time difference in seconds
    } else {
      time = parseInt(timerWrap.data('time'), 10);
    }

    if (time <= 0) return timerWrap.hide(); // Ensures valid countdown

    const update = () => {
      if (time < 0) return timerWrap.hide();
      timer.text([Math.floor(time / 3600), Math.floor((time % 3600) / 60), time % 60]
        .map(v => v.toString().padStart(2, '0')).join(':'));
      time--;
    };

    update();
    setInterval(update, 1000);
  }


  // Initialize section code
  if ($('.announcement__timer').length > 0) {
    AnnouncementTimer();
    $('.announcement__text a').on('click', function (e) {
      e.preventDefault();
      var text = $(this).text().trim();
      copyToClipboard(text);
      log.collapse(text, 'Copied to Clipboard');
    });
  }

  $('.ScrollToProduct').on('click', function (e) {
    e.preventDefault();
    const targets = ['#product-main', '.bdp_form', '#buy-now'];
    const target = targets.filter(target => $(target).length > 0)[0];
    if (!target) return;

    // Find the closest target element to the current scroll position
    const targetElements = $(target);
    const offset = 200;
    if (targetElements.length > 1) {
      const scrollPos = $(window).scrollTop();
      const closest = targetElements.toArray().reduce((prev, curr) =>
        Math.abs($(curr).offset().top - scrollPos) < Math.abs($(prev).offset().top - scrollPos) ? curr : prev
      );
      $('html, body').animate({ scrollTop: $(closest).offset().top - offset }, 600);
    } else {
      $('html, body').animate({ scrollTop: targetElements.offset().top - offset }, 600);
    }
  });

  $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });


});